export default class {
    constructor() {
        return {
            COUNTY_TO_TRACK_FOR_ANALYTICS: [
                'Broome',
                'Chenango',
                'Delaware',
                'Otsego',
                'Tioga'
            ]
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/Constants.js